import {
  WEB_HOOK_SUBSCRIPTION_EVENT_TYPE,
  WebhookSubscriptionEventItem,
  USERSROLE
} from 'types';

export const getEventLabel = (type: string, isAll = false) => {
  const {
    ENQUIRY_CREATE,
    USER_CREATE,
    USER_UPDATE,
    REFERRAL_CREATE,
    REFERRAL_UPDATE,
    RESPONSE_CREATE
  } = WEB_HOOK_SUBSCRIPTION_EVENT_TYPE;
  switch (type) {
    case ENQUIRY_CREATE:
      return `Enquiry create${isAll ? '' : ' (personal)'}`;
    case USER_CREATE:
      return `User create`;
    case USER_UPDATE:
      return `User update`;
    case REFERRAL_CREATE:
      return `Referral create${isAll ? '' : ' (personal)'}`;
    case REFERRAL_UPDATE:
      return `Referral update${isAll ? '' : ' (personal)'}`;
    case RESPONSE_CREATE:
      return `Response create${isAll ? '' : ' (personal)'}`;
    default:
      return '';
  }
};

export const getEventTitle = (role: string) => {
  switch (role) {
    case USERSROLE.AOVIEWER:
    case USERSROLE.AOADMIN:
      return 'Organisation event types';
    default:
      return 'Special event types';
  }
};

export const getEventHelpText = (role: string) => {
  switch (role) {
    case USERSROLE.AOVIEWER:
    case USERSROLE.AOADMIN:
      return 'Organisation subscriptions affect your organisation’s enquiries';
    default:
      return 'Special subscriptions are for BYDA administrators';
  }
};

export const allUserEvents: WebhookSubscriptionEventItem[] = [
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.ENQUIRY_CREATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.ENQUIRY_CREATE)
  },
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.RESPONSE_CREATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.RESPONSE_CREATE)
  }
];

export const aoAdminEvents: WebhookSubscriptionEventItem[] = [
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.REFERRAL_CREATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.REFERRAL_CREATE, true)
  },
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.REFERRAL_UPDATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.REFERRAL_UPDATE, true)
  },
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.RESPONSE_CREATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.RESPONSE_CREATE, true)
  }
];

export const dbydAdminEvents: WebhookSubscriptionEventItem[] = [
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.ENQUIRY_CREATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.ENQUIRY_CREATE, true)
  }
];

export const sysAdminEvents: WebhookSubscriptionEventItem[] = [
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.USER_CREATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.USER_CREATE, true)
  },
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.USER_UPDATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.USER_UPDATE, true)
  },
  {
    status: 'empty',
    type: WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.ENQUIRY_CREATE,
    label: getEventLabel(WEB_HOOK_SUBSCRIPTION_EVENT_TYPE.ENQUIRY_CREATE, true)
  }
];
